import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse } from 'reactstrap';
import UIKitIcon from '../../../shared/UIKITComponents/Icon';
import { colors } from '../../../shared/theme';

const TopbarHelp: React.FC = () => {
  const { t } = useTranslation();
  const [collapse, setCollapse] = useState(false);

  const toggle = () => setCollapse((value) => !value);
  const leave = () => {
    if (collapse) {
      toggle();
    }
  };

  return (
    <div className="topbar__help">
      <button
        title="Help"
        type="button"
        className="topbar__help__icon"
        onClick={toggle}
        id="NotificationPopover"
      >
        <UIKitIcon style={{ color: colors.specialColors.white }} name="help_outlined" />
      </button>
      <Collapse
        isOpen={collapse}
        className="topbar__collapse-content submenu-collapse user-options"
        navbar
        onMouseLeave={leave}
      >
        <div className="topbar__nav-link">
          <div className="topbar__nav-title">Usefull Links</div>
          <a
            href="https://idbg.sharepoint.com/sites/ESG_Compass"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('compassComSite')}
          </a>
        </div>
        <div className="topbar__nav-link">
          <div className="topbar__nav-title">Version Number</div>
          <div className="topbar__nav-content">{process.env.REACT_APP_VERSION}</div>
        </div>
      </Collapse>
    </div>
  );
};

export default TopbarHelp;
